import { getDisplayName } from './profile';

export function normalizeSearch(s) {
  return String(s ?? '').trim().toLowerCase();
}

/**
 * @param {Array<{ id: string, email?: string, username?: string }>} recipients
 * @param {string} query
 * @param {(r: object) => string} [labelFn]
 */
export function filterRecipients(recipients, query, labelFn = getDisplayName) {
  const q = normalizeSearch(query);
  if (!q) return [...recipients];
  return recipients.filter((r) => {
    const name = normalizeSearch(labelFn(r));
    const email = normalizeSearch(r?.email);
    const username = normalizeSearch(r?.username);
    return name.includes(q) || email.includes(q) || username.includes(q);
  });
}
